<script setup lang="ts">
defineProps<{
  title: string;
  message?: string;
}>();
</script>
<template>
  <div class="rounded-md bg-red-50 p-4">
    <div class="flex items-center">
      <div class="flex-shrink-0">
        <ui-icon name="CircleX" class="h-5 w-5 text-red-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-semibold text-red-800 text-start">{{ title }}</h3>
        <div v-if="message" class="mt-2 text-sm text-red-700">
          <p class="text-start">{{ message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
